<template>
  <div v-if="tags && tags.length > 0" class="tag-list-wrapper">
    <!-- <span v-if="mode === 'select'" class="tag-label">{{ labelText }}</span> -->
    <swiper
      :slides-per-view="'auto'"
      :space-between="8"
      :free-mode="true"
      :modules="[FreeMode]"
      class="tag-swiper"
    >
      <swiper-slide
        v-for="tag in tags"
        :key="tag.id"
        class="tag-item"
        :class="{ active: isSelected(tag.id) }"
        :style="getTagStyle(tag)"
        @click.stop="handleTagClick(tag)"
      >
        #{{ tag.name }}
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

interface Tag {
  id: number | string;
  name: string;
  color: string;
}

interface Props {
  tags: Tag[];
  mode?: "display" | "select";
  selectedTagIds?: (number | string)[];
}

const props = withDefaults(defineProps<Props>(), {
  mode: "display",
  selectedTagIds: () => [],
});

const { t } = useI18n();

const labelText = computed(() => {
  return `#${t("post.create.topicLabel")}：`;
});

const emit = defineEmits<{
  (e: "tag-toggle", tagId: number | string): void;
}>();

const router = useRouter();

const isSelected = (tagId: number | string) => {
  return props.mode === "select" && props.selectedTagIds.includes(tagId);
};

const getTagStyle = (tag: Tag) => {
  if (props.mode === "select" && isSelected(tag.id)) {
    return {
      backgroundColor: tag.color,
      borderColor: tag.color,
      color: "#fff",
    };
  }
  return {
    borderColor: tag.color,
    color: tag.color,
  };
};

const handleTagClick = (tag: Tag) => {
  // 验证 tag.id 是否存在，避免 undefined.toString() 崩溃
  if (tag.id === undefined || tag.id === null) {
    return;
  }

  if (props.mode === "select") {
    emit("tag-toggle", tag.id);
  } else {
    // display 模式下，自动跳转到标签页面
    router.push({
      path: "/page",
      query: {
        tagId: String(tag.id),
        tagName: tag.name,
        tagColor: tag.color,
      },
    });
  }
};
</script>

<style lang="scss" scoped>
.tag-list-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tag-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.tag-swiper {
  flex: 1;
  min-width: 0;
  width: 0;
  position: relative;
}

.tag-swiper :deep(.swiper-wrapper) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.tag-swiper :deep(.swiper-slide) {
  width: auto !important;
}

.tag-item {
  padding: 4px 8px;
  border: 1px solid;
  border-radius: 16px;
  font-size: 10px;
  user-select: none;
  background: #fff;
  white-space: nowrap;
  width: auto !important;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }
}
@media (min-width: 768px) {
  .tag-item {
    font-size: 14px;
  }
}
</style>
